import { render } from "./ciudades.vue?vue&type=template&id=18dad659&scoped=true"
import script from "./ciudades.vue?vue&type=script&lang=js"
export * from "./ciudades.vue?vue&type=script&lang=js"

import "./ciudades.vue?vue&type=style&index=0&id=18dad659&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dad659"]])

export default __exports__